import React from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import { ReactComponent as ChevronDown } from '../assets/images/chevron-down.svg';

const FaqList = ({ faqItems, activeItems, handleToggleFAQ, hasTitle, centralOffice, openChat }) => {
        const navigate = useNavigate();
  
  return (
    <div className="faq-container">
    {
        hasTitle ?  (
            <h2>پرسش‌های پرتکرار مشتریان</h2>
        ) : null
    }

      {faqItems.map((faq, index) => (
        <div onClick={() => handleToggleFAQ(index)} className={`faq-item ${activeItems.includes(index) ? 'active-faq' : ''}`} key={index}>
          <div className="title" >
            <div className="drop-down-button">
              <ChevronDown className='drop-down-icon'/>
            </div>
            <div className="text-container">
              <h5>{faq.question}</h5>
            </div>
          </div>
          {activeItems.includes(index) && (
            <div className="expand-body">
              <span>{faq.answer}</span>
              
              {/* Special boxes for specific FAQ items */}
              {faq.hasSpecialBoxes && (
                <div className="special-info-boxes">
                  {faq.address && (
                    <div 
                      className="info-box address-box"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (centralOffice) {
                          const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                          const isAndroid = /android/i.test(userAgent);
                          const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
                          
                          if (isAndroid) {
                            window.location.href = `geo:${centralOffice.lat},${centralOffice.lon}`;
                          } else if (isIOS) {
                            window.location.href = `maps://maps.apple.com/?q=${centralOffice.lat},${centralOffice.lon}`;
                          } else {
                            window.open(`https://www.google.com/maps?q=${centralOffice.lat},${centralOffice.lon}`, '_blank', 'noopener,noreferrer');
                          }
                        }
                      }}
                    >
                      <div className="info-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 0C4.686 0 2 2.686 2 6C2 9.314 8 16 8 16S14 9.314 14 6C14 2.686 11.314 0 8 0ZM8 8C6.895 8 6 7.105 6 6C6 4.895 6.895 4 8 4C9.105 4 10 4.895 10 6C10 7.105 9.105 8 8 8Z" fill="#2337A9"/>
                        </svg>
                      </div>
                      <span>{faq.address}</span>
                    </div>
                  )}
                  
                  {faq.phone && (
                    <a href='tel:02157523' className="info-box phone-box">
                      <div className="info-icon">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.5 11.7C14.3 11.7 13.1 11.4 12 10.9C11.9 10.8 11.7 10.7 11.5 10.8L9.3 12.1C7.1 10.9 5.1 8.9 3.9 6.7L5.2 4.5C5.3 4.3 5.2 4.1 5.1 4C4.6 2.9 4.3 1.7 4.3 0.5C4.3 0.2 4.1 0 3.8 0H0.5C0.2 0 0 0.2 0 0.5C0 8.8 7.2 16 15.5 16C15.8 16 16 15.8 16 15.5V12.2C16 11.9 15.8 11.7 15.5 11.7Z" fill="#2337A9"/>
                        </svg>
                      </div>
                      <span>{faq.phone}</span>
                    </a>
                  )}
                </div>
              )}
              
              {faq.action === 'openChat' ? (
                <a onClick={openChat} className="small-btn">{faq.button}</a>
              ) : (
                <a href={faq.link} target='_blank' className="small-btn">{faq.button}</a>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default FaqList;
